<template lang='pug'>
	#app
		.swiper-container#side-menu-swiper
			HistorySnackbars
			GiveFeedback
			.swiper-wrapper
				sidebar.swiper-slide
				#main.swiper-slide
					#full-page-views
						course-info

						campus-select-popup

						user-swiper
							.give-feedback-wrapper(slot='after-sign-out-button')
								.give-feedback(@click='giveFeedback') give feedback

						upload-errors


					router-view
</template>

<script>
import Sidebar from '@/components/Sidebar';
import CourseInfo from '@/components/CourseInfo';
import UserSwiper from '@/components/UserSwiper';
import UploadErrors from '@/components/UploadErrors';
import HistorySnackbars from '@/components/HistorySnackbars';
import GiveFeedback from '@/components/GiveFeedback';
import store from '@/store';
import CampusSelectPopup from '@/components/CampusSelectPopup';

export default {
  name       : 'app',
  components : {
    Sidebar,
    CourseInfo,
    UserSwiper,
    UploadErrors,
    HistorySnackbars,
    GiveFeedback,
    CampusSelectPopup
  },
  store,

  data : () => ( {
    sideMenuTimeout : null,
  } ),

  computed : {
    sideMenuSwiper() {
      return this.$store.state.sideMenuSwiper;
    },
    courseInfoState() {
      return this.$store.state.courseInfoState;
    },
    campusSelectState() {
      return this.$store.state.campusSelectState;
    },
    userLoading() {
      return this.$store.getters.userLoading;
    },
    schoolsLoading() {
      return this.$store.getters.schoolsLoading;
    },
    savedSchool() {
      return this.$store.getters.savedSchool;
    }
  },

  beforeCreate() {
    this.$store.dispatch( 'initAuthListeners' )
      .then( () => {
        // this.$store.dispatch( 'getCatalog' );
        this.$store.dispatch( 'initCatalogListeners' );
      } );
  },

  mounted() {
    this.$store.dispatch( 'initSideMenuSwiper' );

    if ( window.innerWidth >= 992 ) {
      this.sideMenuSwiper.slideTo( 0 );

      window.setTimeout( () => {
        this.$store.dispatch( 'destroySideMenuSwiper' );
      }, 200 );
    }

    window.addEventListener( 'resize', ( e ) => {
      const { innerWidth : w } = e.target;
      clearTimeout( this.sideMenuTimeout );

			this.sideMenuTimeout = setTimeout( () => { // eslint-disable-line

        // must correspond to the size of the
        // mobile & tablet media query found
        // at the bottom of index.scss, as well
        // as the number used in sidebarVM.created()
        if ( w < 992 ) {
          this.$store.dispatch( 'initSideMenuSwiper' );
          return;
        }

        this.sideMenuSwiper.slideTo( 0 );

        window.setTimeout( () => {
          this.$store.dispatch( 'destroySideMenuSwiper' );
        }, 200 );
      }, 200 );
    } );
  },

  watch : {
    // Open campus select if the user hasn't yet picked a school
    // Only open once user and schools have both been opened (hence the two watchers)
    userLoading : {
      immediate : true,
      handler() {
        this.openCampusSelect();
      }
    },
    schoolsLoading : {
      immediate : true,
      handler() {
        this.openCampusSelect();
      }
    }
  },

  methods : {
    giveFeedback() {
      // eslint-disable-next-line no-undef
      // SpacebarFeedback.open();
      this.$store.dispatch( 'openGiveFeedback' );
    },
    openCampusSelect() {
      if ( !this.schoolsLoading && !this.userLoading && this.savedSchool === '' ) {
        this.$store.dispatch( 'openCampusSelect' );
      }
    }
  },
};
</script>


<style lang="scss">
	@import '@/assets/default.scss';

	#app {

		#full-page-views {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 20;
			pointer-events: none;

			.swiper-container {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				pointer-events: none;

				.swiper-wrapper .swiper-slide {
					background-color: white;
					box-shadow: 0 0 0 rgba(0,0,0,0);
					transition: box-shadow 0.2s ease;
					will-change: box-shadow;

					&.open {
						box-shadow: $floatingObject;
					}

					&.empty {
						background-color: transparent;

						&.pointer-events,
						+ .swiper-slide {
							pointer-events: all;
						}
					}
				}
			}
		}

		.give-feedback-wrapper {
			flex: 1 1 0;
			display: flex;
			align-items: flex-end;
			justify-content: center;
			padding: 30px;

			.give-feedback {
				color: $primary;
				text-transform: uppercase;
				letter-spacing: 5px;
				cursor: pointer;
			}
		}

		#main {
			width: calc( 100vw - 300px );
		}

		@media only screen and (min-width : 1px) and (max-width : 992px) {
			#main {
				width: calc( 100vw ) !important;
			}
		}

	}
</style>
